export default __webpack_public_path__ + "static/media/sample.45f7bd2d.mp3";